import { render, staticRenderFns } from "./officialPassportApp.vue?vue&type=template&id=784e25a6&"
import script from "./officialPassportApp.vue?vue&type=script&lang=js&"
export * from "./officialPassportApp.vue?vue&type=script&lang=js&"
import style0 from "./officialPassportApp.vue?vue&type=style&index=0&id=784e25a6&prod&lang=css&"
import style1 from "./officialPassportApp.vue?vue&type=style&index=1&id=784e25a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports